import {OwnerPayload, TeamId, UserId, UserMin} from "platformed-client/types";
import {unreachableCase} from "./typescript.ts";

export function getContentId(owner: OwnerPayload): UserId | TeamId {
  switch (owner.type) {
    case "User":
      return owner.content.user_id;
    case "Team":
      return owner.content.team_id;
    default:
      unreachableCase(owner);
  }
}

export function getOwnerNames(owner: OwnerPayload): string[] {
  switch (owner.type) {
    case "User":
      return [owner.content.name, owner.content.primary_email].flatMap(n => (n ? [n] : []));
    case "Team":
      return [owner.content.name];
    default:
      unreachableCase(owner);
  }
}

export function isPlatformedUser(user: UserMin) {
  return (user.primary_email ?? "").endsWith("@platformed.com");
}
